import { all, takeLatest, fork } from "redux-saga/effects";
import { cleanAction } from "./customers/actions";

import {
  createArea,
  getAreaById,
  get as getAreas,
  getCitys,
  getDistrict,
  getDistricts,
  getPoints,
  searchArea,
  updateArea,
} from "./areas/sagas";
import { AreaTypes } from "./areas/types";

import { checkEmail as checkEmailLogin, doLogin } from "./login/sagas";
import { LoginTypes } from "./login/types";

import { doLogin as directDoLogin } from "./directLogin/sagas";
import { LoginTypes as DirectLoginTypes } from "./directLogin/types";

import {
  createCompanyCustomer,
  createPermission,
  get,
  getAddress as getAddressCustomer,
  getCustomerById,
  loadPermission,
  searchCustomer,
  updateCompanyCustomer,
  updatePermissionCustomer,
  updateSettings,
} from "./customers/sagas";
import { CustomerTypes } from "./customers/types";

import {
  store as createCompany,
  getAddress,
  get as getCompanies,
  getCompaniesById,
  getById as getCompanyById,
  searchCompany,
  update as updateCompany,
} from "./companies/sagas";
import { CompanyTypes } from "./companies/types";

import {
  get as getSpecialties,
  getById as getSpecialtyById,
  searchSpecialty,
  store as storeSpecialty,
  update as updateSpecialty,
} from "./specialties/sagas";
import { SpecialtyTypes } from "./specialties/types";

import {
  getById as getCouncilById,
  get as getCouncils,
  searchConcil,
  store as storeCouncil,
  update as updateCouncil,
} from "./councils/sagas";
import { CouncilTypes } from "./councils/types";

import {
  getByScore as getByScoreDocuments,
  get as getDocuments,
  getByCareId as getDocumentsByCareId,
  store as storeDocuments,
} from "./documents/sagas";
import { DocumentTypes } from "./documents/types";

import {
  get as getDocumentGroups,
  getByIds as getDocumentGroupsByIds,
} from "./documentGroups/sagas";
import { DocumentGroupTypes } from "./documentGroups/types";

import {
  createPatient,
  getAddress as getAddressPatient,
  getPatientById,
  getPatientCapture,
  get as getPatients,
  searchPatient,
  updatePatient,
} from "./patients/sagas";
import { PatientTypes } from "./patients/types";

import { get as getLayout } from "./layout/sagas";
import { LayoutTypes } from "./layout/types";

import { get as getMessage, getMessageById } from "./message/sagas";
import { MessageTypes } from "./message/types";

import { UserTypes } from "./users/types";

import {
  loadPrescriptionByCareId,
  loadPrescriptionWithItems,
  loadReportCheck,
  loadReportByDate as loadReportPrescriptionByDate,
  loadReportUnique as loadReportPrescriptionUnique,
} from "./prescripition/saga";
import { PrescriptionTypes } from "./prescripition/types";

import {
  get as getAntibiotic,
  loadReportUnique as loadReportAntibioticUnique,
} from "./antibiotic/sagas";
import { AntibioticTypes } from "./antibiotic/types";

//import { CareTypes } from './cares/types';
import {
  checkEmail,
  createUser,
  getAddress as getAddressUser,
  getByClient,
  getProfessions,
  getUserByEmail,
  getUserByExternalId,
  getUserById,
  get as getUsers,
  getUserTypes,
  loadGetUserDisengaged,
  recoveryPassword,
  recoverypasswordiftoken,
  searchUser,
  searchUserDisengaged,
  storeUser,
  updateCompanies,
  updateCompaniesLinks,
  updateUser,
  updateUserPassword,
  updatingUser,
} from "./users/sagas";

import {
  createCare,
  deleteCare,
  deleteSchedule,
  getAccommodationType,
  getAllCid,
  getCareById,
  get as getCares,
  getCareType,
  getChekin,
  getChekInReport,
  getDocumentAbemid,
  getDocumentGroupAbemid,
  getDocumentGroupNead,
  getDocumentGroupSocioAmbiental,
  getDocumentNead,
  getDocumentSocioAmbiental,
  getEvolution,
  getFilterAdverseEvent,
  getFilterAllergy,
  getFilterCheckin,
  getFilterEvolution,
  getFilterMeasurement,
  getHealthInsurance,
  getHealthPlan,
  getHealthSubPlan,
  getHistory,
  getPopUp as getPatient,
  getReleaseReason,
  getReleaseReferral,
  getSchedule,
  search as searchCare,
  searchCid,
  storeDocumentAbemid,
  storeDocumentNead,
  storeDocumentSocioAmbiental,
  storeSchedule,
  transferCare,
  updateCare,
  updateDocumentAbemid,
  updateDocumentNead,
  updateDocumentSocioAmbiental,
  updateSchedule,
} from "./cares/sagas";
import { CareTypes } from "./cares/types";

import { get as getProfession } from "./professions/sagas";
import { ProfessionTypes } from "./professions/types";

import { load as getAllergies } from "./allergies/sagas";
import { AllergiesTypes } from "./allergies/types";

import { get as getMeasurements } from "./measurements/sagas";
import { MeasurementsTypes } from "./measurements/types";

import { createQrCode, get as getQrCode, updateQrCode } from "./qrCode/sagas";
import { QrCodeTypes } from "./qrCode/types";

import { get as getExams } from "./exams/sagas";
import { ExamsTypes } from "./exams/types";

import { get as getAttests } from "./attest/sagas";
import { AttestTypes } from "./attest/types";

import { get as getLogo } from "./logo/sagas";
import { LogoTypes } from "./logo/types";

import { get as getAttachments, getFile } from "./attachment/sagas";
import { AttachmentTypes } from "./attachment/types";

import {
  getFilterTelemedicine,
  getlinkTelemedicine,
  getReportByDay as getReportByDayTemeledicine,
  getReportUnique as getReportUniqueTelemedicine,
  get as getTelemedicine,
} from "./telemedicine/sagas";
import { TelemedicineTypes } from "./telemedicine/types";

import {
  getFilterForms,
  getForms,
  getFormsGroupByDate,
  getFormsTabs,
} from "./forms/sagas";
import { FormTypes } from "./forms/types";

import { getCustomerLogs } from "./customerLogs/sagas";
import { CustomerLogsTypes } from "./customerLogs/types";

import {
  dispatchDocsForIntegration,
  verifyStatus as verifyStatusDocsIntegration,
} from "./attachmentsIntegration/sagas";
import { AttachmentsIntegrationTypes } from "./attachmentsIntegration/types";

import {
  createOpinion,
  get as getOpinions,
  getData as getOpinionsData,
  listPriorities,
  listSpecialities,
} from "./opinions/sagas";
import { OpinionTypes } from "./opinions/types";

import { getToken } from "./digitalSignature/sagas";
import { DigitalSignatureTypes } from "./digitalSignature/types";
import { ReasonDischargeTypes } from "./reasonDischarge/types";
import { searchReasonDischarge } from "./reasonDischarge/sagas";
import { getIntegratedDocuments, getIntegratedDocumentsLogs } from "./integrationDocuments/sagas";
import { DataSyncTypes } from "./integrationDocuments/types";
import {
  createAnswer,
  get as getOpinion,
  getData as getOpinionData,
} from "./opinion/sagas";
import { OpinioTypes } from "./opinion/types";
import { getOrigins, getPanel } from "./panel/sagas";
import { PanelTypes } from "./panel/types";
import {
  getExamsByAttendanceId,
  getPatientsForRevaluation,
  getRevaluationAttendanceById,
  postAttendance,
  updateAttendanceStatus,
} from "./revaluation/sagas";
import { RevaluationTypes } from "./revaluation/types";
import {
  cancelTelemedicineDocument,
  createTelemedicineDocument,
  getAttendanceById,
  getAttendanceMeetUrl,
  getBiomeasuresByAttendance,
  getPatientsForTelemedicine,
  getTelemedicineDocumentsByType,
  updateAttendance,
  getTelemedicineGuestData,
  changeRoomInProvider,
  createConsentTerm,
} from "./telemedicineAttendances/sagas";
import { TelemedicineAttendancesTypes } from "./telemedicineAttendances/types";

// monitoring dashboard
import { MonitoringTypes } from "./monitoring/types";
import { get as getMonitoring } from "./monitoring/sagas";

import checkinSaga from "./checkin/sagas";

// Discharge
import { DischargeTypes } from "./discharge/types";
import { get as getDischarge, loadReasons, submit as submitDischarge } from "./discharge/sagas";


export default function* rootSaga(): any {
  return yield all([
    takeLatest(LoginTypes.LOAD_REQUEST, doLogin),
    takeLatest(DirectLoginTypes.LOAD_REQUEST, directDoLogin),
    takeLatest(LoginTypes.EMAIL_REQUEST, checkEmailLogin),
    takeLatest(UserTypes.UPDATE_USER_PASSWORD, updateUserPassword),
    // takeLatest(AreaTypes.LOAD_REQUEST, getAreas),
    // takeLatest(EspecialtyTypes.LOAD_REQUEST, getEspecialty),
    // takeLatest(CouncilTypes.LOAD_REQUEST, getCouncil),
    // takeLatest(CustomerTypes.LOAD_REQUEST, get),

    // Area
    takeLatest(AreaTypes.LOAD_REQUEST, getAreas),
    takeLatest(AreaTypes.LOAD_REQUEST_AREA_BY_ID, getAreaById),
    takeLatest(AreaTypes.CREATE_AREA_REQUEST, createArea),
    takeLatest(AreaTypes.UPDATE_AREA_REQUEST, updateArea),
    takeLatest(AreaTypes.LOAD_GET_DISTRICTS, getDistricts),
    takeLatest(AreaTypes.LOAD_GET_CITYS, getCitys),
    takeLatest(AreaTypes.LOAD_GET_DISTRICTS_, getDistrict),
    takeLatest(AreaTypes.SEARCH_REQUEST, searchArea),
    takeLatest(AreaTypes.LOAD_POINTS_AREA, getPoints),
    takeLatest(AreaTypes.CLEAN, cleanAction),

    // Care
    takeLatest(CareTypes.LOAD_REQUEST, getCares),
    takeLatest(CareTypes.LOAD_PATIENT_REQUEST, getPatient),
    takeLatest(CareTypes.LOAD_REQUEST_CARE_BY_ID, getCareById),
    takeLatest(CareTypes.CREATE_CARE_REQUEST, createCare),
    takeLatest(CareTypes.UPDATE_CARE_REQUEST, updateCare),
    takeLatest(CareTypes.SEARCH_CARE_REQUEST, searchCare),

    takeLatest(
      CareTypes.DOCUMENT_GROUP_SOCIOAMBIENTAL_REQUEST,
      getDocumentGroupSocioAmbiental
    ),
    takeLatest(
      CareTypes.DOCUMENT_SOCIOAMBIENTAL_REQUEST,
      getDocumentSocioAmbiental
    ),
    takeLatest(
      CareTypes.DOCUMENT_SOCIOAMBIENTAL_STORE_REQUEST,
      storeDocumentSocioAmbiental
    ),
    takeLatest(
      CareTypes.DOCUMENT_SOCIOAMBIENTAL_UPDATE_REQUEST,
      updateDocumentSocioAmbiental
    ),

    takeLatest(CareTypes.DOCUMENT_GROUP_ABEMID_REQUEST, getDocumentGroupAbemid),
    takeLatest(CareTypes.DOCUMENT_ABEMID_REQUEST, getDocumentAbemid),
    takeLatest(CareTypes.DOCUMENT_ABEMID_STORE_REQUEST, storeDocumentAbemid),
    takeLatest(CareTypes.DOCUMENT_ABEMID_UPDATE_REQUEST, updateDocumentAbemid),

    takeLatest(CareTypes.DOCUMENT_GROUP_NEAD_REQUEST, getDocumentGroupNead),
    takeLatest(CareTypes.DOCUMENT_NEAD_REQUEST, getDocumentNead),
    takeLatest(CareTypes.DOCUMENT_NEAD_STORE_REQUEST, storeDocumentNead),
    takeLatest(CareTypes.DOCUMENT_NEAD_UPDATE_REQUEST, updateDocumentNead),

    takeLatest(CareTypes.HEALTH_INSURANCE_REQUEST, getHealthInsurance),
    takeLatest(CareTypes.HEALTH_PLAN_REQUEST, getHealthPlan),
    takeLatest(CareTypes.HEALTH_SUBPLAN_REQUEST, getHealthSubPlan),
    takeLatest(CareTypes.TYPE_ACCOMMODATION_REQUEST, getAccommodationType),
    takeLatest(CareTypes.CARE_TYPE_REQUEST, getCareType),
    takeLatest(CareTypes.SEARCH_CID_REQUEST, searchCid),
    takeLatest(CareTypes.LOAD_CID_REQUEST, getAllCid),
    takeLatest(CareTypes.LOAD_RELEASE_REASON_REQUEST, getReleaseReason),
    takeLatest(CareTypes.LOAD_RELEASE_REFERRAL_REQUEST, getReleaseReferral),
    //takeLatest(CareTypes.LOAD_DOCUMENT_REQUEST, getDocumentById),

    takeLatest(CareTypes.LOAD_SCHEDULE_REQUEST, getSchedule),
    takeLatest(CareTypes.CREATE_SCHEDULE_REQUEST, storeSchedule),
    takeLatest(CareTypes.DELETE_SCHEDULE_REQUEST, deleteSchedule),
    takeLatest(CareTypes.UPDATE_SCHEDULE_REQUEST, updateSchedule),

    takeLatest(CareTypes.LOAD_HISTORY_REQUEST, getHistory),
    takeLatest(CareTypes.TRANSFER_CARE_REQUEST, transferCare),
    takeLatest(CareTypes.DELETE_CARE_REQUEST, deleteCare),

    takeLatest(CareTypes.LOAD_EVOLUTION_REQUEST, getEvolution),

    takeLatest(CareTypes.LOAD_CHECKIN_REQUEST, getChekin),
    takeLatest(CareTypes.LOAD_CHECKIN_REPORT_REQUEST, getChekInReport),
    takeLatest(CareTypes.LOAD_CHECKIN_FILTER_REQUEST, getFilterCheckin),
    takeLatest(CareTypes.LOAD_EVOLUTION_FILTER_REQUEST, getFilterEvolution),
    takeLatest(CareTypes.LOAD_MEASUREMENT_FILTER_REQUEST, getFilterMeasurement),
    takeLatest(CareTypes.LOAD_ALLERGY_FILTER_REQUEST, getFilterAllergy),
    takeLatest(
      CareTypes.LOAD_ADVERSE_EVENT_FILTER_REQUEST,
      getFilterAdverseEvent
    ),

    // Council
    takeLatest(CouncilTypes.LOAD_REQUEST, getCouncils),
    takeLatest(CouncilTypes.LOAD_REQUEST_COUNCIL_BY_ID, getCouncilById),
    takeLatest(CouncilTypes.CREATE_COUNCIL_REQUEST, storeCouncil),
    takeLatest(CouncilTypes.UPDATE_COUNCIL_REQUEST, updateCouncil),
    takeLatest(CouncilTypes.SEARCH_REQUEST, searchConcil),

    // Specialty
    takeLatest(SpecialtyTypes.LOAD_REQUEST, getSpecialties),
    takeLatest(SpecialtyTypes.LOAD_REQUEST_SPECIALTY_BY_ID, getSpecialtyById),
    takeLatest(SpecialtyTypes.CREATE_SPECIALTY_REQUEST, storeSpecialty),
    takeLatest(SpecialtyTypes.UPDATE_SPECIALTY_REQUEST, updateSpecialty),
    takeLatest(SpecialtyTypes.SEARCH_REQUEST, searchSpecialty),

    // Company
    takeLatest(CompanyTypes.LOAD_REQUEST, getCompanies),
    takeLatest(CompanyTypes.LOAD_REQUEST_ADDRESS, getAddress),
    takeLatest(CompanyTypes.LOAD_REQUEST_COMPANY_BY_ID, getCompanyById),
    takeLatest(CompanyTypes.CREATE_COMPANY_REQUEST, createCompany),
    takeLatest(CompanyTypes.UPDATE_COMPANY_REQUEST, updateCompany),
    takeLatest(CompanyTypes.SEARCH_REQUEST, searchCompany),
    takeLatest(CompanyTypes.LOAD_REQUEST_CUSTOMER_BY_ID, getCompaniesById),

    /** Customers */
    takeLatest(CustomerTypes.LOAD_REQUEST, get),
    takeLatest(CustomerTypes.LOAD_REQUEST_BY_ID, getCustomerById),
    takeLatest(CustomerTypes.LOAD_REQUEST_ADDRESS, getAddressCustomer),
    takeLatest(CustomerTypes.CREATE_CUSTOMER_REQUEST, createCompanyCustomer),
    takeLatest(CustomerTypes.UPDATE_CUSTOMER_REQUEST, updateCompanyCustomer),
    takeLatest(CustomerTypes.SEARCH_REQUEST, searchCustomer),
    takeLatest(CustomerTypes.LOAD_REQUEST_PERMISSION, loadPermission),
    takeLatest(
      CustomerTypes.UPDATE_PERMISSION_REQUEST,
      updatePermissionCustomer
    ),
    takeLatest(CustomerTypes.CREATE_PERMISSION_REQUEST, createPermission),
    takeLatest(CustomerTypes.UPDATE_SETTINGS_REQUEST, updateSettings),

    // Documents
    takeLatest(DocumentTypes.LOAD_REQUEST, getDocuments),
    takeLatest(DocumentTypes.CREATE_DOCUMENT_REQUEST, storeDocuments),
    takeLatest(DocumentTypes.LOAD_REQUEST_BY_CARE_ID, getDocumentsByCareId),
    takeLatest(DocumentTypes.LOAD_REQUEST_GET_BY_SCORE, getByScoreDocuments),

    // Document Groups
    takeLatest(DocumentGroupTypes.LOAD_REQUEST, getDocumentGroups),
    takeLatest(
      DocumentGroupTypes.LOAD_REQUEST_DOCUMENTS_BY_ID,
      getDocumentGroupsByIds
    ),

    /** Patients */
    takeLatest(PatientTypes.LOAD_REQUEST, getPatients),
    takeLatest(PatientTypes.CREATE_PATIENT_REQUEST, createPatient),
    takeLatest(PatientTypes.LOAD_REQUEST_ADDRESS, getAddressPatient),
    takeLatest(PatientTypes.LOAD_REQUEST_PATIENT_BY_ID, getPatientById),
    takeLatest(PatientTypes.UPDATE_PATIENT_REQUEST, updatePatient),
    takeLatest(PatientTypes.SEARCH_REQUEST, searchPatient),
    takeLatest(PatientTypes.LOAD_PATIENT_CAPTURE, getPatientCapture),

    /** Users */
    takeLatest(UserTypes.LOAD_REQUEST, getUsers),
    takeLatest(UserTypes.CREATE_USER_REQUEST, createUser),
    takeLatest(UserTypes.LOAD_REQUEST_CHECK_EMAIL, checkEmail),
    takeLatest(UserTypes.LOAD_REQUEST_ADDRESS, getAddressUser),
    takeLatest(UserTypes.LOAD_REQUEST_USER_BY_ID, getUserById),
    takeLatest(UserTypes.LOAD_REQUEST_USER_BY_EMAIL, getUserByEmail),
    takeLatest(UserTypes.UPDATE_USER_REQUEST, updateUser),
    takeLatest(UserTypes.SEARCH_REQUEST, searchUser),
    takeLatest(UserTypes.LOAD_REQUEST_PROFESSION, getProfessions),
    takeLatest(UserTypes.LOAD_REQUEST_USER_TYPES, getUserTypes),
    takeLatest(UserTypes.LOAD_REQUEST_RECOVERY_PASSWORD, recoveryPassword),
    takeLatest(UserTypes.LOAD_REQUEST_USER_DISENGAGED, loadGetUserDisengaged),
    takeLatest(UserTypes.SEARCH_REQUEST_USER_DISENGAGED, searchUserDisengaged),
    takeLatest(
      UserTypes.LOAD_REQUEST_RECOVERY_PASSWORD_TOKEN,
      recoverypasswordiftoken
    ),
    takeLatest(UserTypes.LOAD_REQUEST_BY_CLIENT, getByClient),
    takeLatest(UserTypes.LOAD_UPDATE_COMPANIES_LINKS, updateCompaniesLinks),
    takeLatest(UserTypes.LOAD_UPDATE_COMPANIES, updateCompanies),
    takeLatest(UserTypes.LOAD_REQUEST_BY_EXTERNAL_ID, getUserByExternalId),
    takeLatest(UserTypes.LOAD_REQUEST_STORE_USER, storeUser),
    takeLatest(UserTypes.LOAD_REQUEST_UPDATE_USER, updatingUser),

    /** Profession */
    takeLatest(ProfessionTypes.LOAD_REQUEST, getProfession),

    /** UnconfirmedUsers */
    //  takeLatest(UnconfirmedUserTypes.LOAD_REQUEST, getUnconfirmedUsers),
    // takeLatest(UnconfirmedUserTypes.CREATE_USER_REQUEST, createUnconfirmedUser),
    //  takeLatest(
    //    UnconfirmedUserTypes.LOAD_REQUEST_USER_BY_ID,
    //    getUnconfirmedUserById
    //  ),
    // takeLatest(UnconfirmedUserTypes.UPDATE_USER_REQUEST, updateUnconfirmedUser),
    // takeLatest(UnconfirmedUserTypes.SEARCH_REQUEST, searchUnconfirmedUser),

    /** Layout */
    takeLatest(LayoutTypes.LOAD_REQUEST, getLayout),

    /** Message */
    takeLatest(MessageTypes.LOAD_REQUEST, getMessage),
    takeLatest(MessageTypes.LOAD_REQUEST_MESSAGE_BY_ID, getMessageById),

    /**
     * ALLERGIES
     */
    takeLatest(AllergiesTypes.LOAD_REQUEST, getAllergies),

    /**
     * MEASUREMENT
     */
    takeLatest(MeasurementsTypes.LOAD_REQUEST, getMeasurements),

    /**
     * QR CODE
     */
    takeLatest(QrCodeTypes.LOAD_REQUEST, getQrCode),
    takeLatest(QrCodeTypes.CREATE_QRCODE_REQUEST, createQrCode),
    takeLatest(QrCodeTypes.UPDATE_QRCODE_REQUEST, updateQrCode),

    /**
     * PRESCRIPTION
     */
    takeLatest(
      PrescriptionTypes.LOAD_REQUEST_PRESCRIPTION_BY_CARE_ID,
      loadPrescriptionByCareId
    ),
    takeLatest(
      PrescriptionTypes.LOAD_REQUEST_WITH_ITEMS,
      loadPrescriptionWithItems
    ),
    takeLatest(
      PrescriptionTypes.LOAD_REQUEST_REPORT_UNIQUE,
      loadReportPrescriptionUnique
    ),
    takeLatest(PrescriptionTypes.LOAD_REQUEST_REPORT_CHECK, loadReportCheck),
    takeLatest(
      PrescriptionTypes.LOAD_REQUEST_REPORT_BY_DATE,
      loadReportPrescriptionByDate
    ),
    /**
     * ANTIBIOTIC
     */
    takeLatest(AntibioticTypes.LOAD_REQUEST, getAntibiotic),
    takeLatest(
      AntibioticTypes.LOAD_REQUEST_REPORT_UNIQUE,
      loadReportAntibioticUnique
    ),

    /**
     * EXAMS
     */

    takeLatest(ExamsTypes.LOAD_REQUEST, getExams),

    /**
     * ATTESTS
     */
    takeLatest(AttestTypes.LOAD_REQUEST, getAttests),

    /**
     * LOGO
     */
    takeLatest(LogoTypes.LOAD_REQUEST, getLogo),

    /**
     * ATTACHMENTS
     */
    takeLatest(AttachmentTypes.LOAD_REQUEST, getAttachments),
    takeLatest(AttachmentTypes.LOAD_REQUEST_FILE, getFile),

    /**
     * TELEMEDICINE
     */
    takeLatest(TelemedicineTypes.LOAD_REQUEST, getTelemedicine),
    takeLatest(
      TelemedicineTypes.LOAD_REQUEST_REPORT_UNIQUE,
      getReportUniqueTelemedicine
    ),
    takeLatest(
      TelemedicineTypes.LOAD_REQUEST_REPORT_BY_DAY,
      getReportByDayTemeledicine
    ),
    takeLatest(
      TelemedicineTypes.LOAD_REQUEST_REPORT_FILTER,
      getFilterTelemedicine
    ),
    takeLatest(
      TelemedicineTypes.LOAD_REQUEST_TELEMEDICINE_URL,
      getlinkTelemedicine
    ),

    /**
     * FORMS
     */
    takeLatest(FormTypes.LOAD_REQUEST, getForms),
    takeLatest(FormTypes.LOAD_FORMS_FILTER_REQUEST, getFilterForms),
    takeLatest(FormTypes.LOAD_FORMS_GROUP_BY_DATE_REQUEST, getFormsGroupByDate),
    takeLatest(FormTypes.LOAD_FORMS_TABS_REQUEST, getFormsTabs),
    /**
     * LOGS
     */
    takeLatest(CustomerLogsTypes.LOAD_REQUEST, getCustomerLogs),
    /**
     * ATTACHMENTS INTEGRATION
     */
    takeLatest(
      AttachmentsIntegrationTypes.DISPATCH_DOCS,
      dispatchDocsForIntegration
    ),
    takeLatest(
      AttachmentsIntegrationTypes.VERIFY_STATUS_DOCS,
      verifyStatusDocsIntegration
    ),

    // Opinions
    takeLatest(OpinionTypes.LOAD_REQUEST, getOpinions),
    takeLatest(OpinionTypes.LOAD_OPINION_REQUEST, getOpinionsData),
    takeLatest(OpinionTypes.LOAD_SELECT_PRIORITY_REQUEST, listPriorities),
    takeLatest(OpinionTypes.LOAD_SELECT_SPECIALITY_REQUEST, listSpecialities),
    takeLatest(OpinionTypes.CREATE_OPINION_REQUEST, createOpinion),

    // Opinions
    takeLatest(OpinioTypes.LOAD_REQUEST, getOpinion),
    takeLatest(OpinioTypes.LOAD_DATA_REQUEST, getOpinionData),
    takeLatest(OpinioTypes.CREATE_ANSWER_REQUEST, createAnswer),

    // Panel
    takeLatest(PanelTypes.LOAD_REQUEST, getPanel),
    takeLatest(PanelTypes.LOAD_REQUEST_ORIGIN, getOrigins),

    //Revaluation
    takeLatest(RevaluationTypes.LOAD_REQUEST, getPatientsForRevaluation),
    takeLatest(RevaluationTypes.LOAD_REQUEST_CREATE_ATTENDANCE, postAttendance),
    takeLatest(
      RevaluationTypes.LOAD_REQUEST_UPDATE_STATUS,
      updateAttendanceStatus
    ),
    takeLatest(
      RevaluationTypes.LOAD_REQUEST_GET_ATTENDANCE_BY_ID,
      getRevaluationAttendanceById
    ),
    takeLatest(RevaluationTypes.LOAD_REQUEST_GET_EXAMS, getExamsByAttendanceId),

    // telemedicineAttendances
    takeLatest(
      TelemedicineAttendancesTypes.LOAD_REQUEST,
      getPatientsForTelemedicine
    ),
    takeLatest(
      TelemedicineAttendancesTypes.LOAD_REQUEST_CREATE_MEET,
      getAttendanceMeetUrl
    ),
    takeLatest(
      TelemedicineAttendancesTypes.LOAD_REQUEST_UPDATE_STATUS,
      updateAttendance
    ),
    takeLatest(
      TelemedicineAttendancesTypes.LOAD_REQUEST_CREATE_DOCUMENT,
      createTelemedicineDocument
    ),
    takeLatest(
      TelemedicineAttendancesTypes.LOAD_REQUEST_GET_DOCUMENT,
      getTelemedicineDocumentsByType
    ),
    takeLatest(
      TelemedicineAttendancesTypes.LOAD_REQUEST_CANCEL_DOCUMENT,
      cancelTelemedicineDocument
    ),
    takeLatest(
      TelemedicineAttendancesTypes.LOAD_REQUEST_GET_BIOMEASURES,
      getBiomeasuresByAttendance
    ),
    takeLatest(
      TelemedicineAttendancesTypes.LOAD_REQUEST_ATTENDANCE_BY_ID,
      getAttendanceById
    ),
    takeLatest(
      TelemedicineAttendancesTypes.LOAD_REQUEST_GUEST_DATA,
      getTelemedicineGuestData
    ),

    takeLatest(
      TelemedicineAttendancesTypes.LOAD_REQUEST_CHANGE_ROOM_IN_PROVIDER,
      changeRoomInProvider
    ),
    takeLatest(
      TelemedicineAttendancesTypes.LOAD_REQUEST_CREATE_CONSENT_TERM,
      createConsentTerm
    ),
    // digitalSignature
    takeLatest(DigitalSignatureTypes.LOAD_REQUEST, getToken),

    // reasonDischarge
    // takeLatest(ReasonDischargeTypes.LOAD_REQUEST, getToken),
    takeLatest(ReasonDischargeTypes.LOAD_REASON_DISCHARGES, searchReasonDischarge),

    // IntegrationDocuments
    takeLatest(DataSyncTypes.LOAD_REQUEST, getIntegratedDocuments),
    takeLatest(DataSyncTypes.LOAD_REQUEST_EXAM_URL, getIntegratedDocuments),
    takeLatest(DataSyncTypes.LOAD_REQUEST_LOGS, getIntegratedDocumentsLogs),

    // Monitoring
    takeLatest(MonitoringTypes.LOAD_REQUEST, getMonitoring),
    fork(checkinSaga),

    // Discharge
    takeLatest(DischargeTypes.LOAD_REQUEST, getDischarge),
    takeLatest(DischargeTypes.SUBMIT_REQUEST, submitDischarge),
    takeLatest(DischargeTypes.LOAD_REASONS_REQUEST, loadReasons),
  ]);
}
